import { get } from 'lodash';

import { ThesaurusTerm } from './thesaurus-term-data-store';

export const preferredTerm = (thesaurusTerm: ThesaurusTerm) =>
    get(thesaurusTerm, 'thesaurusTermCS.preferredTerm', null);
